module.exports = __webpack_public_path__ + "static/img/1_0018.5410015.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0018.jpg
// module id = 3mMf
// module chunks = 0